import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
  },
  loading: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 200,
  },
});
